import React, { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import axios from "axios";
import Cookies from "js-cookie";
import { toast, ToastContainer } from "react-toastify";
import {
  Card,
  CardBody,
  Col,
  Container,
  Form,
  Input,
  Row,
} from "reactstrap";
import "react-toastify/dist/ReactToastify.css";

const TwostepVerification = () => {
  const [otp, setOtp] = useState("");
  const [secret, setSecret] = useState("");
  const [loading, setLoading] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();
  const BASE_URL_BE = process.env.REACT_APP_BASE_URL_BE;
  const API_KEY = process.env.REACT_APP_API_KEY;

  // Ambil secret dari URL
  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const secretParam = params.get("secret");

    if (!secretParam) {
      toast.error("Secret tidak ditemukan di URL");
    }

    setSecret(secretParam || "");
  }, [location.search]);

  const handleInputChange = (e) => {
    const value = e.target.value;
    if (value.length <= 6) {
      setOtp(value);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (otp.length !== 6) {
      toast.error("OTP harus 6 karakter");
      return;
    }

    if (!secret) {
      toast.error("Secret tidak valid");
      return;
    }

    setLoading(true);

    try {
      const formData = new FormData();
      formData.append("grant_type", "otp");
      formData.append("secret", secret);
      formData.append("code", otp);

      const response = await axios.post(`${BASE_URL_BE}/auth/login`, formData, {
        headers: {
          "x-api-key": API_KEY,
        },
      });

      const token = response.data?.data?.access_token;

      if (token) {
        // Simpan token di cookie untuk 18 jam (0.75 hari)
        Cookies.set("access_token", token, {
          expires: 0.75,
          secure: window.location.protocol === "https:",
          sameSite: "Strict",
        });
      }

      toast.success(response.data.message);
      navigate("/dashboard");

    } catch (error) {
      console.error("Error verifying OTP:", error);
      if (error.response?.data?.message) {
        toast.error(error.response.data.message);
      } else {
        toast.error("Gagal verifikasi OTP");
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="account-pages my-5 pt-sm-5">
      <Container>
        <Row className="justify-content-center">
          <Col md={8} lg={6} xl={5}>
            <Card>
              <CardBody>
                <h4 className="text-center">Verifikasi OTP Anda</h4>
                <p className="text-center">Masukkan 6 digit kode yang dikirim ke email Anda</p>

                <Form onSubmit={handleSubmit}>
                  <Input
                    type="text"
                    className="form-control form-control-lg text-center mb-3"
                    maxLength="6"
                    value={otp}
                    onChange={handleInputChange}
                    placeholder="Masukkan OTP"
                    disabled={loading}
                  />
                  <button type="submit" className="btn btn-success w-100" disabled={loading}>
                    {loading ? "Memverifikasi..." : "Verifikasi"}
                  </button>
                </Form>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
      <ToastContainer />
    </div>
  );
};

export default TwostepVerification;
